import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IAllMeetingStatsPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const allMeetingStatsSlice = createSlice({
    name: 'meeting-statistics/all-meeting-stats',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAllMeetingStatsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const allMeetingStatsActions = allMeetingStatsSlice.actions
export default allMeetingStatsSlice.reducer
